import { createContext } from "react"

import type { TextConfirmationDialogConfig } from "./typings"

export type TextConfirmationDialogContextType = (func: (close: () => void) => TextConfirmationDialogConfig) => void

export const TextConfirmationDialogContext = createContext<TextConfirmationDialogContextType>(() => {
	throw new Error("No IssueDialogProvider found")
})
